function getLayerType(layerUuid) {
    if (layerUuid === 'Renderer') return '3D';

    let layerData = Q3.data.layers.layers2D[layerUuid];
    if (!layerData) return null;

    let objectData = layerData.objects && Object.values(layerData.objects)[0];
    if (!objectData) return null;

    return objectData.type;
}

const typeOrder = [['3D'], ['line'], ['picture'], ['circleSlider', 'atomUi', 'terrainCarUi', 'emFieldUi', 'cylinderInfo', ['mmmInfo']], ['button', 'slider', 'tabexplorer'], ['text', 'mathFormula']];
const typeIndex = {};
for (let [i, types] of typeOrder.entries()) {
    for (let type of types) {
        typeIndex[type] = i;
    }
}

function getDefaultOrderIndex(layers, layerUuid) {
    let type = getLayerType(layerUuid);
    if (!type) return;

    let thisIndex = typeIndex[type];

    let lowerLayer = null;
    for (let otherLayer of layers) {
        if (!otherLayer.reordered && otherLayer.uuid !== layerUuid) {
            let otherType = getLayerType(otherLayer.uuid);
            let otherIndex = typeIndex[otherType];
            if (otherIndex === undefined || otherIndex <= thisIndex) lowerLayer = otherLayer;
        }
    }

    if (!lowerLayer) {
        return layers.length;
    } else {
        return lowerLayer.index+1;
    }
}

function applyDefaultOrder(layers, layerUuid) {
    let newIndex = getDefaultOrderIndex(layers, layerUuid);

    let layer = Q3.layers.list[layerUuid];
    let oldIndex = layer.index;

    if (layers[oldIndex] === layer) {
        layers.splice(oldIndex, 1);

        if (newIndex > oldIndex) newIndex--;
    }

    layers.splice(newIndex, 0, layer);

    Q3.layers.updateChildrenIndices(layers.filter(x=>x));
    Q3.layers.update();
}

function applyValidOrder(layers) {
    let compareLayers = (l1, l2) => {
        let data1 = Q3.data.layers.layers2D[l1.uuid];
        let data2 = Q3.data.layers.layers2D[l2.uuid];
        let l1HasReorder = data1 && data1.reordered !== undefined;
        let l2HasReorder = data2 && data2.reordered !== undefined;
        if (l1HasReorder !== l2HasReorder) {
            return Number(l1HasReorder)-Number(l2HasReorder);
        }

        if (l1HasReorder) {
            return l1.index-l2.index;
        }

        let typeIndex1 = typeIndex[getLayerType(l1.uuid)];
        let typeIndex2 = typeIndex[getLayerType(l2.uuid)];
        if (typeIndex1 !== typeIndex2) {
            return typeIndex1-typeIndex2;
        }

        return l1.index-l2.index;
    };

    layers.sort(compareLayers);

    for (let [i, layer] of layers.entries()) {
        layer.index = i;
        layer.reordered = Boolean(layer.reordered);

        let layerData = Q3.data.layers.layers2D[layer.uuid];
        if (layerData) {
            layerData.index = i;
            layerData.reordered = layer.reordered;
        }
    }
}

function applyValidOrderToLayerData(slide) {
    let compareLayers = (uuid1, uuid2) => {
        let data1 = Q3.data.layers.layers2D[uuid1];
        let data2 = Q3.data.layers.layers2D[uuid2];
        let l1HasReorder = data1 && data1.reordered !== undefined;
        let l2HasReorder = data2 && data2.reordered !== undefined;
        if (l1HasReorder !== l2HasReorder) {
            return Number(l1HasReorder)-Number(l2HasReorder);
        }

        if (l1HasReorder && (data1.reordered || data2.reordered)) {
            return data1.index-data2.index;
        }

        let typeIndex1 = typeIndex[getLayerType(uuid1)];
        let typeIndex2 = typeIndex[getLayerType(uuid2)];
        if (typeIndex1 !== typeIndex2) {
            return typeIndex1-typeIndex2;
        }

        return data1.index-data2.index;
    };

    let slideData = Q3.data.slides[slide];

    let layers = [];
    for (let uuid in slideData.layers2D) {
        layers.push(uuid);
    }
    layers.sort(compareLayers);

    for (let [index, uuid] of layers.entries()) {
        Q3.data.layers.layers2D[uuid].index = Q3.layers.minimumUserLayerIndex+index;
    }
}

export { getDefaultOrderIndex, applyDefaultOrder, applyValidOrder, applyValidOrderToLayerData };
export default applyDefaultOrder;
